import { useEffect, useLayoutEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const SITE = "86’d Operations";
const META = {
  "/": ["86’d — Restaurant operations platform", "Daily sales, manager handoffs, tip-outs, inventory and team accountability in one restaurant operations platform. 14-day free trial, no credit card."],
  "/pricing": ["Pricing", "Essential, Operations Pro and Group plans for restaurants, per location, monthly or annual."],
  "/training": ["Training & implementation", "Optional paid training and guided launch packages for 86’d, with defined scope."],
  "/signup": ["Start your free trial", "Create your 86’d account: 14-day free trial, no credit card required."],
  "/login": ["Log in", "Log in to 86’d Operations."],
  "/forgot-password": ["Reset your password", "Reset your 86’d password."],
  "/profit-leak-calculator": ["Profit leak calculator", "Estimate areas of your operation worth a closer look against targets you choose."],
  "/find-your-plan": ["Find your plan", "Answer a few questions to see which 86’d plan fits your restaurant."],
  "/discover": ["Discover restaurants", "Find restaurants on 86’d Discover."],
  "/for-restaurants": ["List your restaurant on Discover", "86’d Discover listing membership for restaurants."],
  "/features": ["Features", "What 86’d does today, by area, with release status."],
  "/compare": ["Compare", "How 86’d compares with other restaurant software."],
  "/what-is-86d": ["What is 86’d?", "A full overview of the 86’d restaurant operations platform, with transcript."],
  "/contact": ["Contact", "Contact 86’d sales, support or privacy."],
  "/support": ["Support", "Get help with 86’d."],
  "/resources": ["Resources", "Articles and guides for restaurant operators."],
  "/privacy": ["Privacy Notice", "86’d pilot Privacy Notice (draft)."],
};

function setMeta(sel, attr, val) {
  let el = document.head.querySelector(sel);
  if (!el) { el = document.createElement(sel.startsWith("link") ? "link" : "meta"); const [, k, v] = sel.match(/\[(\w+)="([^"]+)"\]/); el.setAttribute(k, v); document.head.appendChild(el); }
  el.setAttribute(attr, val);
}

export function RouteMeta() {
  const { pathname, hash } = useLocation();
  const nav = useNavigationType();
  const first = useRef(true);
  useLayoutEffect(() => {
    if (pathname.startsWith("/app") || pathname.startsWith("/admin")) return;
    const [t, d] = META[pathname] || [null, null];
    document.title = t ? (pathname === "/" ? t : `${t} | ${SITE}`) : SITE;
    if (d) { setMeta('meta[name="description"]', "content", d); setMeta('meta[property="og:description"]', "content", d); }
    setMeta('meta[property="og:title"]', "content", document.title);
    setMeta('link[rel="canonical"]', "href", `${window.location.origin}${pathname}`);
  }, [pathname]);
  useEffect(() => {
    if (first.current && !hash) { first.current = false; return; }
    first.current = false;
    if (hash && !hash.includes("=")) {
      const go = (n) => { const el = document.getElementById(decodeURIComponent(hash.slice(1))); if (el) el.scrollIntoView({ block: "start" }); else if (n) setTimeout(() => go(n - 1), 150); };
      go(10);
      return;
    }
    if (nav !== "POP") {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      document.getElementById("main")?.focus({ preventScroll: true });
    }
  }, [pathname, hash, nav]);
  return null;
}
